export const appDoneIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd"><path fill="currentColor" d="M9.09 15.493L5.274 11.73 4 12.985 9.09 18 20 7.254 18.727 6z"/></g></svg>`,
    name: 'done' as const
};